export default __webpack_public_path__ + "static/media/RESPONSIVE_DESIGN.bf66c61f.jpg";